<template>
  <div class="c-timer">
    <svg class="c-timer__svg" viewBox="0 0 120 120">
      <circle
        class="progress__meter"
        cx="60"
        cy="60"
        r="54"
        stroke-width="12"
        :stroke="colors.primaryOpacity"
      />
      <circle
        class="progress__value"
        cx="60"
        cy="60"
        r="54"
        stroke-width="12"
        stroke-dasharray="339.292"
        :stroke-dashoffset="circle"
        :stroke="colors.primary"
      />
    </svg>
    <div class="c-timer__count">{{ time || 0 }}s</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Timer",
  props: ["maxTime", "currentTime"],
  computed: {
    ...mapGetters(["colors"]),
    circle() {
      //60 55
      const progress = this.currentTime / this.maxTime;
      const CIRCUMFERENCE = 2 * Math.PI * 54;
      return CIRCUMFERENCE * (1 - progress);
    },
    time() {
      return Math.floor(this.currentTime);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-timer {
  height: 100px;
  width: 100px;
  padding: 4px;
  position: relative;
}
.progress-circle {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.c-timer__svg {
  transform: rotate(-90deg);
}

.progress__meter,
.progress__value {
  fill: none;
}
.c-timer__count {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 25px;
  color: hsl(0, 0%, 0%);
}
</style>
